/**
 * =============================================================================
 * LAYOUT - Componente de Layout Principal
 * =============================================================================
 *
 * Este componente envolve todas as páginas do site, fornecendo:
 * - Navbar fixa no topo
 * - Conteúdo principal (Outlet do React Router)
 * - Footer no rodapé
 *
 * O Outlet renderiza a página atual conforme a rota ativa.
 * O pt-[72px] compensa a altura da navbar fixa para que o
 * conteúdo não fique escondido por baixo da barra.
 *
 * Como usar: Este componente é usado como layout pai no App.tsx
 * com React Router. Todas as rotas filhas herdam este layout.
 */

import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { CookieBanner } from "@/components/cookies/CookieBanner";
import { CookiePreferences } from "@/components/cookies/CookiePreferences";

export default function Layout() {
  return (
    <div className="flex flex-col min-h-screen">
      {/* ==========================================
          NAVBAR - Barra de navegação fixa no topo
          Altura: 72px (compensada no main)
          ========================================== */}
      <Navbar />

      {/* ==========================================
          CONTEÚDO PRINCIPAL
          - flex-1: ocupa todo o espaço disponível
          - pt-[72px]: compensa a altura da navbar fixa
          - Outlet: renderiza a página atual (React Router)
          ========================================== */}
      <main className="flex-1 pt-[72px]">
        <Outlet />
      </main>

      {/* ==========================================
          FOOTER - Rodapé do site
          ========================================== */}
      <Footer />

      {/* ==========================================
          COOKIES - Banner e painel de preferências
          ========================================== */}
      <CookieBanner />
      <CookiePreferences />
    </div>
  );
}
